var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{attrs:{"input-options":_vm.inputOptions,"defaultCountry":"UA","autoFormat":false,"mode":"international","valid-characters-only":true},on:{"input":function($event){return _vm.$emit('input', _vm.val)}},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})
}
var staticRenderFns = []

export { render, staticRenderFns }